import { ChangeEventHandler, useCallback } from 'react';
import GroupLabel from '../GroupLabel';
import { Center, Checkbox, rem } from '@mantine/core';
import { GroupCheckboxProps } from './types';

const groupCheckboxIcon = () => null;

export default function GroupCheckbox({
  group,
  active,
  labelProps,
  readonly,
  onToggleGroup,
  onSelectGroup,
  onUnselectGroup,
}: GroupCheckboxProps) {
  const onClick = useCallback(() => {
    onToggleGroup?.(group, !active);
    if (active) {
      onUnselectGroup?.(group);
    } else {
      onSelectGroup?.(group);
    }
  }, [group, active, onSelectGroup, onUnselectGroup, onToggleGroup]);

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      event.stopPropagation();
      onClick();
    },
    [onClick],
  );

  return (
    <GroupLabel
      key={group.id}
      group={group}
      style={{ cursor: readonly ? 'text' : 'pointer' }}
      hoverable={!readonly}
      inactive={!active}
      onClick={onClick}
      {...labelProps}
      before={
        <Center w={12} h={12} onClick={(e) => e.stopPropagation()}>
          <Checkbox
            size={rem(active ? 10 : 12)}
            radius="xl"
            checked={active}
            icon={groupCheckboxIcon}
            onChange={onChange}
            styles={{
              input: {
                '--checkbox-color': 'var(--groupTextColor)',
                transition: 'none',
                cursor: readonly ? 'default' : 'pointer',
              },
            }}
          />
        </Center>
      }
    />
  );
}
